import { Component, OnInit, Output, EventEmitter, ViewContainerRef } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Subject } from 'rxjs';
import { MemoService } from 'src/app/services/memo/memo.service';
import { ModalService } from 'src/app/services/modal/modal.service';
import { StringUtilsService } from 'src/app/services/string-utils/string-utils.service';
import { CreateDestinataireMemo } from 'src/app/utils/interfaces/new/create-destinataire-memo.interface';
import { CreateMemo } from 'src/app/utils/interfaces/new/create-memo.interface';
import { Destinataire } from 'src/app/utils/interfaces/new/destinataire.interface';
import { LocalAuth } from 'src/app/utils/interfaces/new/localauth.interface';
import { Mailbox } from 'src/app/utils/interfaces/new/mailbox.interface';
import { Memo } from 'src/app/utils/interfaces/new/memo.interface';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-memo',
  templateUrl: './memo.fragment.html',
  styleUrls: ['./memo.fragment.scss', '../modal.fragment.scss'],
})


export class MemoFragment implements OnInit {

  public header = '';
  public author: LocalAuth;
  public authorName: string;
  public date: string | Date;
  public memoFormGroup: FormGroup;
  public mode: string = '';
  public editMemo: Memo;
  public users: Destinataire[] = [];
  public selectedUsers: number[];
  public noEdit: boolean = false;
  public usersName: any = [];
  public newUtilisateur: any = {};
  public refreshStream: Subject<any>;

  @Output() public closeEmitter = new EventEmitter();

  constructor(
    private formBuilder: FormBuilder,
    public viewContainerRef: ViewContainerRef,
    public modalService: ModalService,
    private memoService: MemoService,
    private _strUtilsSrv: StringUtilsService,
  ) { }

  ngOnInit(): void {
    this.date = this.mode != 'create' ? this.editMemo.creationDate : new Date();
    const author = this.users.find(user => user.id === this.editMemo?.auteur); 
    if (author) {
      const qualite = author.qualite ? author.qualite + " " : "";
      this.authorName = `${qualite} ${author.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(author.prenom)}`;
    } else {
     this.authorName = `${this.author.utilisateur.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(this.author.utilisateur.prenom)}`;
    if (this.author.profil.qualite) {
      this.authorName = this.author.profil.qualite + " " + this.authorName
    }
    } 
    if (this.mode === 'edit') {
      for (let destinataire of this.editMemo.destinataires) {
        let userName = `${destinataire.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)}`;
        if (destinataire.qualite) {
          userName = " " + destinataire.qualite + " " + userName;
        }
        this.usersName.push(userName);
      }
      this.memoFormGroup = this.formBuilder.group({
        msg: [this.editMemo.message, [Validators.required, Validators.minLength(5)]],
      });
    } else if (this.mode === 'editPage') {
      for (let destinataire of this.editMemo.destinataires) {
        let userName = `${destinataire.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)}`;
        if (destinataire.qualite) {
          userName = " " + destinataire.qualite + " " + userName;
        }
        this.usersName.push(userName);
        if (destinataire.processed || destinataire.disabled) {
          this.noEdit = true;
        } else {
          this.noEdit = false;
        }
      }
      this.memoFormGroup = this.formBuilder.group({
        msg: [this.editMemo.message, [Validators.required, Validators.minLength(5)]],
      });

    }
    else {
      for (let destinataire of this.users) {
        if (!destinataire.disabled) {
          let userName = `${destinataire.nom.toLocaleUpperCase()} ${this._strUtilsSrv.uppercaseFirstCharString(destinataire.prenom)}`;
          if (destinataire.qualite) {
            userName = destinataire.qualite + " " + userName;
          }
          this.newUtilisateur = {
            id: destinataire.id,
            name: userName
          }
          this.usersName.push(this.newUtilisateur);
        }
      }

      this.memoFormGroup = this.formBuilder.group({
        receiver: ['', Validators.required],
        msg: ['', [Validators.required, Validators.minLength(3)]],
      });
    }
  }


  public clickOuside(): void {
    if (!environment.closeModalOnClickOutside) {
      return;
    }
    this.closeMemoModal();
  }

  public closeMemoModal(): void {
    this.closeEmitter.emit(null);
  }

  public async onSubmit(): Promise<void> {
    const loader = this.modalService.openLoading(this.viewContainerRef);
    try {
      this.memoFormGroup.markAllAsTouched();
      if (this.mode === 'create') {
        if (this.memoFormGroup.valid) {
          let listOfDestinataire = [];
          for (let idProfilDestinataire of this.memoFormGroup.get('receiver').value) {
            const newdestinataires: CreateDestinataireMemo = {
              idProfil: idProfilDestinataire,
            }
            listOfDestinataire.push(newdestinataires);
          }
          const memo: CreateMemo = {
            auteur: this.author.profil.id,
            message: this.memoFormGroup.get('msg').value,
            destinataires: listOfDestinataire,
          }
          await this.memoService.create(memo);
          this.modalService.close(loader);
          this.closeMemoModal();
          this.refreshStream.next("memo");
        }
        else {
          this.modalService.close(loader);
        }
      } else {
        if (this.memoFormGroup.valid) {
          const updateMemo: Memo = {
            id: this.editMemo.id,
            auteur: this.editMemo.auteur,
            message: this.memoFormGroup.get('msg').value,
          }
          await this.memoService.updateMemo(updateMemo);
          this.modalService.close(loader);
          this.closeMemoModal();
          this.refreshStream.next("memo");
        } else {
          this.modalService.close(loader);
        }
      }
    } catch (e) {
      this.modalService.close(loader);
      throw e;
    }
  }

  public async processedMemo() {
    const modal = this.modalService.openModalConfirmation(this.viewContainerRef, 'Confirmation', 'Voulez-vous vraiment considérer ce mémo comme traité ? Si vous êtes le seul destinataire, ce mémo sera archivé.');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loader = this.modalService.openLoading(this.viewContainerRef);
        try {
          if (this.editMemo.destinataires.length > 1) {
            for (let destinataire of this.editMemo.destinataires) {
              const updateMemoStatus: Mailbox = {
                idMemo: this.editMemo.id,
                idProfil: this.author.profil.id,
                disabled: destinataire.disabled,
                processed: true,
              }
              await this.memoService.updateStatus(updateMemoStatus);
              this.closeMemoModal();
              this.refreshStream.next("memo");
              this.modalService.close(loader);
            }
          } else {
            const updateMemoStatus: Mailbox = {
              idMemo: this.editMemo.id,
              idProfil: this.author.profil.id,
              disabled: true,
              processed: true,
            }
            await this.memoService.updateStatus(updateMemoStatus);
            this.modalService.close(loader);
            this.closeMemoModal();
            this.refreshStream.next("memo");
          }
        } catch (e) {
          this.modalService.close(loader);
          throw e;
        }
      }
    });
  }

  public async disabledMemo() {
    const modal = this.modalService.openModalConfirmation(this.viewContainerRef, 'Confirmation', 'Voulez-vous vraiment vous retirer des destinataires ? Si vous êtes le seul destinataire, ce mémo sera supprimé.');
    modal.instance.closeEmitter.subscribe(async (res: boolean) => {
      if (res) {
        const loader = this.modalService.openLoading(this.viewContainerRef);
        try {
          const updateMemoStatus: Mailbox = {
            idMemo: this.editMemo.id,
            idProfil: this.author.profil.id,
            disabled: true,
            processed: this.editMemo.destinataires[0].processed,
          }
          await this.memoService.updateStatus(updateMemoStatus);
          this.closeEmitter.emit();
          this.modalService.close(loader);
          this.refreshStream.next("memo");
        } catch (e) {
          this.modalService.close(loader);
          throw e;
        }
      }
    });
  }


  public stopPropagation(event: any): void {
    event.stopPropagation();
  }
}
